import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import '../App.css';
import QuestionList from './QuestionList';
import CuriosoReveal from './CuriosoReveal';
import Title from './Title';

class App extends Component {
  render() {
    return (
      <Switch>
        <Route path="/" component={Title} exact={true} />
        <Route path="/quiz/:questionIndex" component={QuestionList} exact={true} />
        <Route path="/share/:encodedCurioso" component={CuriosoReveal} exact={false} />
        <Route path="/curioso/:encodedCurioso" component={CuriosoReveal} exact={false} />
      </Switch>
    );
  }
}

export default App;
